module.exports = {
    // What We Do Section ---------------------------------------------------------------------------------------------------------------------
    HEADING_WHAT_WE_DO: "Perect solution for Your Business",
    TEXT_WHAT_WE_DO: "What we do",
    // Who are we section ---------------------------------------------------------------------------------------------------------------------
    HEADING_WHO_WE_ARE: "Let us INTRODUCE OURSELF",
    TEXT_WHO_WE_ARE: "Who we are",
    // We are good in section ---------------------------------------------------------------------------------------------------------------------
    HEADING_WE_ARE_GOOD_IN: "We provide Services In",
    TEXT_WE_ARE_GOOD_IN: "We are good in",
    // Latest News section ---------------------------------------------------------------------------------------------------------------------
    HEADING_LATEST_NEWS: "What’s New?",
    TEXT_LATEST_NEWS: "Latest News",
    // We are here section ---------------------------------------------------------------------------------------------------------------------
    HEADING_WE_ARE_HERE: "You can ping us or have a cup of COFFEE OVER HERE",
    TEXT_WE_ARE_HERE: "We are here",
    // Things we have made section ---------------------------------------------------------------------------------------------------------------------
    HEADING_THINGS_WE_HAVE_MADE: "Work completed for our HAPPY CLIENTS",
    TEXT_THINGS_WE_HAVE_MADE: "Things we've made",
}